<template>
  <portal to="subPageActions">
    <div slot-scope="props" class="sub-page-actions">
      <transition name="slide-top">
        <div class="sub-page-actions__block" v-show="!$slots.interactiveBlock || (!props.contentUnderHeader && $slots.interactiveBlock)">
          <slot></slot>
        </div>
      </transition>
      <transition name="slide-bottom-small">
        <div class="sub-page-actions__block sub-page-actions__block--interactive" v-show="props.contentUnderHeader && $slots.interactiveBlock">
          <slot name="interactiveBlock"></slot>
        </div>
      </transition>
    </div>
  </portal>
</template>

<script>
export default {}
</script>

<style lang="scss">
.sub-page-actions {
  position: relative;

  &__block {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }
}
</style>
